import { NJModal, NJModalContent, NJButton, NJFormItem } from '@engie-group/fluid-design-system-react';
import { useState, useEffect } from 'react';

function ModalAddUser({ isOpen, handleAddUser, handleCancel }) {

    const [gid, setGid] = useState('');

    useEffect(() => {
        setGid('');
    }, [isOpen]);

    return (
        <NJModal
            id="modalAddUser"
            isOpen={isOpen}
        >
            <NJModalContent
                footer={
                    <>
                        <NJButton
                            emphasis="bold"
                            variant="secondary"
                            label="Cancel"
                            onClick={handleCancel}
                        />
                        <NJButton
                            label="Add Admin user"
                            icon="person_add_alt"
                            iconClassName="material-icons-outlined"
                            disabled={!gid}
                            onClick={() => { handleAddUser(gid) }}
                        />
                    </>
                }
                icon="person_add_alt"
                id="modalAddUser"
                onClose={handleCancel}
                title={'Add new Admin user'}
            >
                <NJFormItem
                    className='dashboard-job-input-hide-label'
                    label="" // "Job description"
                    name="myInput"
                    onChange={(e) => setGid(e.target.value)}
                    value={gid}
                    labelKind="static"
                    placeholder='Enter user GID'
                />
            </NJModalContent>
        </NJModal>
    )
}

export default ModalAddUser;
